import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceRuleItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'attendance-rule-item'
  }

}